<template>
  <section>
    <div class="row">
      <div class="col">
        <p>
          This will simulate the capture of scale data from a scale for a given
          user. It will generate random data and broadcast this data every
          second to any client "listening" on another browser having the portal
          open and when viewing the "Scale Measurement" dialog in that User's
          profile (under the Body Comp tab).
        </p>
        <p>
          To start the test, be sure this page is open and ready. Then, in the
          second browser, open the "Scale Measurement" dialog. This will trigger
          the simulator to start sending data.
        </p>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="row">
          <div class="col-2">
            <z-input v-model="userId" label="User ID" type="number" />
          </div>
          <div class="col-1 custom-scale">
            <i v-if="isContinue" class="fas fa-weight fa-pulse"></i>
          </div>
          <div class="col-2 pt-4">
            <span class="me-2">Weight</span
            ><span>{{ formatNumber(measurement.weight) }}</span>
          </div>
          <div class="col-2 pt-4">
            <span class="me-2">Body Fat</span
            ><span>{{ formatNumber(measurement.percentBodyFat) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-2">
        <button class="btn btn-primary custom-start-button" @click="cancelSim">
          Cancel
        </button>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col">
        <span class="me-2">Weight</span><span>{{ measurement.weight }}</span>
      </div>
      <div class="col">
        <span class="me-2">Body Fat</span><span>{{ measurement.fat }}</span>
      </div>
    </div> -->
  </section>
</template>
<script>
import ZInput from '@/Components/ZElements/Input'
export default {
  name: 'scale-sim',
  components: {
    ZInput,
  },
  data() {
    return {
      isContinue: false,
      simTimer: null,
      userId: 218,
      isData: false,
      isGetData: false,
      protocol: 1,
      measurement: {
        weight: 0,
        percentBodyFat: 0,
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.measurement = {
        weight: 0,
        percentBodyFat: 0,
      }
      this.channel = Echo.join('direct').listenForWhisper(
        'scaleaction',
        (e) => {
          if (parseInt(e.userId) === parseInt(this.userId)) {
            if (e.action === 'start') {
              this.protocol = e.protocol
              this.startSim(e.data)
            } else if (e.action === 'stop') {
              this.stopSim()
            }
          }
        }
      )
    },
    formatNumber(number) {
      let value = null
      if (number) {
        value = parseFloat(number).toFixed(1)
      }
      return value
    },
    generateBaseline(data) {
      let newData = {
        weight: 0,
        percentBodyFat: 0,
        vFat: 0,
        bmi: 0,
        bmr: 0,
        boneKg: null,
        muscleKg: null,
        waterPct: null,
      }
      var direction = Math.round(Math.random())
      var change = Math.floor(Math.random() * 10)
      if (direction > 0) {
        // added weight
        newData.weight = data.weight + change
        newData.percentBodyFat = data.percentBodyFat + change / 3
      } else {
        // reduced weight
        newData.weight = data.weight - change
        newData.percentBodyFat = data.percentBodyFat - change / 3
      }
      return newData
    },
    generateScaleData(data) {
      var offset = Math.floor(Math.random() * 2)
      var direction = Math.round(Math.random())
      if (direction === 0) {
        data.weight += offset * -1
        data.percentBodyFat += offset * -1
      } else {
        data.weight += offset
        data.percentBodyFat += offset
      }
      return data
    },
    async startSim(data) {
      let $this = this
      this.isContinue = true
      if (data === undefined || data === null) {
        data = {
          weight: 158,
        }
      }
      this.measurement = this.generateBaseline({
        weight: data.weight,
        percentBodyFat: 15,
      })
      console.log('Scale Simulator Started', this.measurement)
      this.simTimer = setInterval(() => {
        $this.measurement = $this.generateScaleData($this.measurement)
        $this.channel.whisper('scale', {
          userId: $this.userId,
          data: $this.measurement,
          action: 'start',
          protocol: $this.protocol,
        })
      }, 1000)
    },
    cancelSim() {
      this.measurement = {
        weight: 0,
        percentBodyFat: 0,
      }
      this.isContinue = false
      clearInterval(this.simTimer)
      this.simTimer = null
      this.channel.whisper('scale', {
        userId: this.userId,
        data: this.measurement,
        action: 'stop2',
        protocol: this.protocol,
      })
    },
    stopSim() {
      this.isContinue = false
      clearInterval(this.simTimer)
      this.simTimer = null
      this.channel.whisper('scale', {
        userId: this.userId,
        data: this.measurement,
        action: 'stop',
        protocol: this.protocol,
      })
      this.measurement = {
        weight: 0,
        percentBodyFat: 0,
      }
    },
  },
  // beforeUnmount() {
  //   Echo.leave('direct')
  // },
}
</script>
<style lang="scss" scoped>
.custom-scale {
  position: relative;
  color: rgb(201, 0, 0);
  text-align: right;
  padding-top: 15px;
  i {
    font-size: 1.2em;
  }
}
/* Icon pulse */
.fa-pulse {
  display: inline-block;
  -moz-animation: pulse 3s infinite linear;
  -o-animation: pulse 3s infinite linear;
  -webkit-animation: pulse 3s infinite linear;
  animation: pulse 3s infinite linear;
}

@-webkit-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-ms-keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
